import { c as _c } from "react/compiler-runtime";
import { CONTACT_API } from 'modules/contacts/api/contact-api';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { SwrPaginationInterface } from 'shared/types/pagination-interface';
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string';
import useSWR from 'swr';
import { ContactId } from '../../types/contact-interface';
import { ContactWorkflowApiInterface } from '../types/contact-workflow-interface';
interface UseContactWorkflowsInterface extends SwrPaginationInterface {
  contactId: ContactId;
}
export function useContactWorkflows(t0) {
  const $ = _c(8);
  const {
    limit,
    pagination,
    contactId
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== contactId || $[2] !== limit || $[3] !== pagination || $[4] !== user) {
    t2 = () => {
      if (user) {
        return `${CONTACT_API}/${contactId}/workflows/list?${getPaginationQueryString({
          limit,
          pagination
        })}`;
      }
      return null;
    };
    $[1] = contactId;
    $[2] = limit;
    $[3] = pagination;
    $[4] = user;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data: contactWorkflows
  } = useSWR(t2, fetcher);
  let t3;
  if ($[6] !== contactWorkflows) {
    t3 = {
      contactWorkflows
    };
    $[6] = contactWorkflows;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}